import { render, staticRenderFns } from "./CorporateROICalculator.vue?vue&type=template&id=6e8f030c&scoped=true"
import script from "./CorporateROICalculator.vue?vue&type=script&lang=js"
export * from "./CorporateROICalculator.vue?vue&type=script&lang=js"
import style0 from "./CorporateROICalculator.vue?vue&type=style&index=0&id=6e8f030c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8f030c",
  null
  
)

export default component.exports